import script from "./JaStreamGroupStreamingTypeModal.vue?vue&type=script&setup=true&lang=js"
export * from "./JaStreamGroupStreamingTypeModal.vue?vue&type=script&setup=true&lang=js"

import "./JaStreamGroupStreamingTypeModal.vue?vue&type=style&index=0&id=3656a926&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3656a926"]])

export default __exports__